module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"wrapper <%= model.viewPeriod %>%>-wrapper\">\n<%\t// build days\nmodel.calendarDays.forEach(function(data) {\n%>\n<div class=\"day<%= data.additionalCSS; %>\" data-date=\"<%= data.date %>\">\n<% if (data.title) { %>\n<div class=\"title\">\n<% if (data.calendarWeek) { %>\n<div class=\"kw\">KW <%= data.calendarWeek %></div>\n<% } %>\n<div class=\"dm\"><%= data.title %></div>\n</div>\n<% } %>\n<div class=\"content\" data-daySelector=\"<%= data.curDaySelector %>\">\n<%\t\t\t\t// are tasks for this day available?\nif (model.tasks[data.curDaySelector]) {\n// append tasks of this day\nmodel.tasks[data.curDaySelector].forEach(function(taskData) {\n%>\t\t\t\t\t\t<%- include('./task', { model: taskData }); %>\n<% \t\t\t\t\t});\n}\n%>\n</div>\n</div>\n<% }); %>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/scheduler/wrapper.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"wrapper ")
    ; __append(escapeFn( model.viewPeriod ))
    ; __append("-wrapper\">\n")
    ; __line = 2
    ; 	// build days
model.calendarDays.forEach(function(data) {

    ; __line = 4
    ; __append("\n<div class=\"day")
    ; __line = 5
    ; __append(escapeFn( data.additionalCSS ))
    ; __append("\" data-date=\"")
    ; __append(escapeFn( data.date ))
    ; __append("\">\n")
    ; __line = 6
    ;  if (data.title) { 
    ; __append("\n<div class=\"title\">\n")
    ; __line = 8
    ;  if (data.calendarWeek) { 
    ; __append("\n<div class=\"kw\">KW ")
    ; __line = 9
    ; __append(escapeFn( data.calendarWeek ))
    ; __append("</div>\n")
    ; __line = 10
    ;  } 
    ; __append("\n<div class=\"dm\">")
    ; __line = 11
    ; __append(escapeFn( data.title ))
    ; __append("</div>\n</div>\n")
    ; __line = 13
    ;  } 
    ; __append("\n<div class=\"content\" data-daySelector=\"")
    ; __line = 14
    ; __append(escapeFn( data.curDaySelector ))
    ; __append("\">\n")
    ; __line = 15
    ; 				// are tasks for this day available?
if (model.tasks[data.curDaySelector]) {
// append tasks of this day
model.tasks[data.curDaySelector].forEach(function(taskData) {

    ; __line = 19
    ; __append("						")
    ; __append( include('./task', { model: taskData }) )
    ; __append("\n")
    ; __line = 20
    ;  					});
}

    ; __line = 22
    ; __append("\n</div>\n</div>\n")
    ; __line = 25
    ;  }); 
    ; __append("\n</div>")
    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/scheduler/wrapper.ejs

}